<template>
  <v-container fluid class="pa-0 ma-0 p-0" style="position: relative; z-index: 1;">
    
    <v-row 
      v-if="loading" 
      class="fill-height ma-0" 
      align="center" 
      justify="center" 
      :style="{ height: alturaCarousel, background: '#121212' }"
    >
      <v-progress-circular indeterminate color="#D32F2F"></v-progress-circular>
    </v-row>

    <v-carousel
      v-else
      cycle
      :height="alturaCarousel"
      hide-delimiter-background
      show-arrows-on-hover
      delimiter-icon="mdi-minus"
      :show-arrows="banners.length > 1 && !$vuetify.breakpoint.xsOnly"
    >
      <v-carousel-item
        v-for="(banner, i) in banners"
        :key="i"
        :src="banner.volume ? banner.volume.url : ''"
        cover
      >
        <div 
          class="fill-height d-flex align-end justify-start" 
          :style="{ 
            background: $vuetify.breakpoint.mdAndUp 
              ? 'linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 100%)' 
              : 'linear-gradient(to right, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.3) 35%, transparent 100%)' 
          }"
        >
          
          <div 
            class="text-left pl-4 pr-2 pl-md-16 pb-12 pb-md-16 mb-md-12" 
            :style="{ maxWidth: $vuetify.breakpoint.xsOnly ? '80%' : '700px' }"
          >
            
            <h1 
              class="font-weight-black white--text text-uppercase mb-1" 
              :class="$vuetify.breakpoint.xsOnly ? 'text-subtitle-1' : 'text-h4 text-md-h3'"
              style="letter-spacing: 1px; line-height: 1.1; text-shadow: 2px 2px 10px rgba(0,0,0,0.8);"
            >
              {{ banner.titulo }}
            </h1>
            
            <p 
              class="white--text font-weight-light mb-10 opacity-90 subtitle-responsive"
              style="text-shadow: 1px 1px 5px rgba(0,0,0,0.8); line-height: 1.2;"
            >
              {{ banner.subTitulo }}
            </p>
            
            <v-btn 
              :large="$vuetify.breakpoint.mdAndUp"
              :small="false" 
              :x-small="$vuetify.breakpoint.xsOnly"
              color="#D32F2F" 
              dark 
              rounded 
              elevation="10"
              class="font-weight-bold mb-1 btn-nano"
              :href="getLink(banner)"
              :target="getTarget(banner)"
            >
              <span class="text-content-nano">
                {{ banner.textoBotao || 'Começar Agora' }}
              </span>
            </v-btn>

          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
    
    <div style="position: absolute; bottom: 0; left: 0; width: 100%; height: 50px; background: linear-gradient(to top, #121212 10%, transparent); pointer-events: none;"></div>
  </v-container>
</template>

<script>
import homePageService from '@/services/home.service';

export default {
  name: 'CarouselBanner',
  data() {
    return {
      loading: true,
      banners: []
    };
  },
  computed: {
    alturaCarousel() {
      if (this.$vuetify.breakpoint.xsOnly) return '60vh'; 
      if (this.$vuetify.breakpoint.smAndDown) return '60vh';
      return '85vh';
    }
  },
  methods: {
    // --- NOVO MÉTODO PARA OBTER O LINK ---
    getLink(banner) {
      if (banner.linkBotao) {
        return banner.linkBotao;
      }
      // Padrão: WhatsApp
      return "https://wa.me/5561998385830?text=Quero%20começar%20a%20mergulhar!";
    },

    // --- NOVO MÉTODO PARA O TARGET (_blank ou _self) ---
    getTarget(banner) {
      // Se for link externo (começa com http), abre em nova aba
      if (banner.linkBotao && banner.linkBotao.startsWith('http')) {
        return '_blank';
      }
      // Se for WhatsApp (sem link personalizado), também abre em nova aba
      if (!banner.linkBotao) {
        return '_blank';
      }
      // Se for link interno (ex: /cursos), abre na mesma aba (spa)
      // Nota: Para links internos reais com vue-router, idealmente usaria :to, 
      // mas href funciona com refresh ou se for ancora.
      return '_self';
    },

    async pegarDados() {
      try {
        this.loading = true;
        const response = await homePageService.getHomePage();
        
        if (Array.isArray(response)) {
          this.banners = response;
        } else if (response) {
          this.banners = [response];
        }
      } catch (error) {
        console.error("Erro ao carregar banners:", error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.pegarDados();
  }
};
</script>

<style scoped>
.v-carousel {
  box-shadow: none !important;
}
.opacity-90 {
  opacity: 0.9;
}

/* --- CLASSE NOVA PARA O SUBTITULO --- */
.subtitle-responsive {
  font-size: 10px !important; 
}

/* --- BOTÃO NANO --- */
.btn-nano {
  height: auto !important;
  min-height: 18px !important;
  padding: 2px 8px !important;
  max-width: 100%;
}

.text-content-nano {
  white-space: normal;
  line-height: 1.0;
  text-align: center;
  font-size: 9px !important;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* --- AJUSTES DESKTOP (MD+) --- */
@media (min-width: 960px) {
  .subtitle-responsive {
    font-size: 16px !important; 
  }

  .btn-nano {
    min-height: 36px !important;
    padding: 0 20px !important;
  }
  .text-content-nano {
    font-size: 12px !important;
    line-height: normal;
  }
}

::v-deep .v-image__image {
  background-position: center center !important;
}
</style>